<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body="{height}">
        <v-sheet
            v-if="!!storeDetail.uidItem && !!currentItem"
            class="px-3 py-3">
          <v-tabs>
            <v-tab>
              <v-chip
                  v-if="!!currentItem.article"
                  label
                  outlined
                  :color="status_tab_article_color"
              >{{ currentItem.article_display }}
              </v-chip>
              <v-chip
                  v-else
                  label
                  outlined
                  :color="status_tab_article_color"
              >Common
              </v-chip>
            </v-tab>
            <v-tab-item>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="5">
                  <v-sheet :height="componentHeight - 75" class="overflow-y-auto px-3">
                    <v-col>
                      <v-chip x-small>
                        <small>
                          {{ $t('octopart_last_update') }}:
                          {{
                            currentItem.update_from_octopart | moment("DD.MM.YY HH:mm")
                          }}
                        </small>
                      </v-chip>
                    </v-col>
                    <v-row dense>
                      <v-col cols="3">
                        <BaseImageCard
                            v-if="!currentItem.is_group"
                            v-model="currentItem.image"
                            :max-height="110"></BaseImageCard>
                        <BaseImageCard
                            v-if="currentItem.is_group"
                            value="/static/images/set-merge.png" :max-height="110"
                            view
                        ></BaseImageCard>
                      </v-col>
                      <v-col cols="9">
                        <v-row v-if="!currentItem.is_group" dense>
                          <v-col cols="8">
                            <CommonFieldString
                                v-model="currentItem.mpn"
                                label="MPN"
                                @input="currentItem.alias = currentItem.mpn"
                                :disabled="currentItem.is_group"
                            ></CommonFieldString>
                          </v-col>
                          <v-col cols="4">
                            <v-checkbox
                                v-model="currentItem.registration_suspect"
                                label="Registration suspect"
                                dense
                                class="mt-n1"
                            >
                            </v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col>
                            <CommonFieldString
                                v-model="currentItem.alias"
                                label="Alias"
                            ></CommonFieldString>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row dence>
                      <v-col cols="2" class="my-0 py-0">
                        <v-chip
                            v-if="!!case_package"
                            :color="case_package.case_package_type_color_dict.color"
                            class="mt-1"
                        >
                          {{
                            case_package.case_package_type_color_dict.text
                          }}
                        </v-chip>
                      </v-col>
                      <v-col cols="6" class="my-0 py-0">
                        <CommonSelectFromTable
                            v-if="case_package_type !== 'PCB'"
                            store-name="SelectCasePackage"
                            label="Case/Package"
                            v-model="currentItem.case_package_uid"
                            dto-list-query="CasePackageListQueryDTO"
                            :sort-by="['name']"
                            prepend-icon="mdi-pencil"
                            @click:prepend="detailStoreCasePackage.openDetailDialog({item: null, uid: case_package.uid})"
                            :error-empty="true"
                        >
                        </CommonSelectFromTable>
                      </v-col>
                      <v-col cols="4" class="my-0 py-0">
                        <ComponentMsdSelect
                            v-if="case_package_type !== 'PCB'"
                            v-model="currentItem.msd_level"
                            label="MSL"
                        ></ComponentMsdSelect>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col class="my-0 py-0">
                        <CommonSelectFromTable
                            v-if="case_package_type !== 'PCB'"
                            label="Subcategory"
                            :store-name="storeSubcategoryName"
                            v-model="currentItem.subcategory_uid"
                            dto-list-query="SubcategoryListQueryDTO"
                            :sort-by="['subcategory']"
                            :sort-desc="[false]"
                            item-text="subcategory"
                            :error-empty="true"
                        >
                        </CommonSelectFromTable>
                        <!--                        store-name="SelectComponentSubcategory"-->
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col class="my-0 py-0">
                        <CommonFieldString
                            v-if="case_package_type !== 'PCB'"
                            label="Category"
                            v-model="category"
                            readonly
                        >
                        </CommonFieldString>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <CommonFieldNumber
                            v-if="case_package_type === 'THT'"
                            v-model="currentItem.number_of_pins"
                            label="Number of pins"
                        ></CommonFieldNumber>
                      </v-col>
                    </v-row>
                    <CoreComponentAttrList
                        v-if="!!currentItem && !!currentItem.key_attributes"
                        v-model="currentItem.key_attributes"
                        :headers="headersAttr"
                        :height="componentHeight - 480"
                        :enable-search="false"
                    >
                    </CoreComponentAttrList>
                  </v-sheet>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="7">
                  <v-sheet
                      v-if="!!currentItem"
                      :height="componentHeight - 75"
                      class="overflow-y-auto pt-3 px-3">
                    <v-tabs fixed-tabs>
                      <v-tab><small>Supply information</small></v-tab>
                      <v-tab-item>
                        <CoreCasePackageSupplyDefault
                            v-if="!!currentItem && !!currentItem.default_supply_information"
                            v-model="currentItem.default_supply_information"
                            :master-supply-information="masterSupplyInformation"
                            :height="650"
                            :supplyRecommendation="false"
                        ></CoreCasePackageSupplyDefault>
                      </v-tab-item>
                      <v-tab :disabled="!!currentItem.is_group">Groups</v-tab>
                      <v-tab-item>
                        <ComponentTable
                            :store-name="storeComponentGroupTableName"
                            :height="componentHeight - 220"
                            :headers="groupsHeaders"
                        >
                          <template v-slot:top.bar.filter>{{ '' }}</template>
                          <template v-slot:footer.prepend>{{ '' }}</template>
                        </ComponentTable>
                      </v-tab-item>
                      <v-tab>Attributes</v-tab>
                      <v-tab-item>
                        <CoreComponentAttrList
                            v-if="!!currentItem && !!currentItem.attributes"
                            v-model="currentItem.attributes.attr_list"
                            :height="componentHeight - 220">
                        </CoreComponentAttrList>
                      </v-tab-item>
                      <v-tab>Details</v-tab>
                      <v-tab-item>
                        <v-sheet class="mt-3">
                          <CommonFieldString
                              v-model="currentItem.description"
                              label="Description"
                              dense
                          ></CommonFieldString>
                          <CommonFieldText
                              v-model="currentItem.information"
                              label="Information"
                              rows="15"
                          ></CommonFieldText>
                          <CommonFieldLink
                              v-model="currentItem.source_url"
                              label="Source"
                              class="mt-3"
                          ></CommonFieldLink>
                          <CommonFieldLink
                              v-model="currentItem.datasheet"
                              label="Datasheet"
                          ></CommonFieldLink>
                        </v-sheet>
                      </v-tab-item>
                      <v-tab>QA</v-tab>
                      <v-tab-item>
                        <CommonHTMXComponent
                            :iframe-src="'/component/quality_control_params/component/' + uidItem + '/'"
                            :height="height - 470"></CommonHTMXComponent>
                      </v-tab-item>
                    </v-tabs>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab :disabled="!currentItem.is_group">Members</v-tab>
            <v-tab-item>
              <ComponentTable
                  title="Component in members"
                  dtoListQuery="ComponentMembersInListQueryDTO"
                  :store-name="storeComponentInMembersTableName"
                  :height="componentHeight / 2 - 190"
                  :headers="membersHeaders"
                  @alternate_action="onAlternateAction($event)"
              >
                <template v-slot:top>{{ '' }}</template>
              </ComponentTable>
              <ComponentTable
                  title="Component out members"
                  dtoListQuery="ComponentMembersOutListQueryDTO"
                  :store-name="storeComponentOutMembersTableName"
                  :height="componentHeight / 2 - 130"
                  detail-store-name="ComponentDetailMembers"
                  :headers="membersHeaders"
                  @alternate_action="onAlternateAction($event)"
              >
              </ComponentTable>
            </v-tab-item>
            <v-tab>Materials</v-tab>
            <v-tab-item>
              <CommonHTMXComponent :iframe-src="'/material/material/?disable_top=true&component_uid=' + uidItem " :height="height - 40"></CommonHTMXComponent>
            </v-tab-item>
            <v-tab>CustomerOrders</v-tab>
            <v-tab-item>
              <v-divider></v-divider>
              <CustomerOrderTable
                  :store-name="storeCustomerOrderTableName"
                  :height="componentHeight - 210"
              >
                <template v-slot:footer.prepend>{{ '' }}</template>
              </CustomerOrderTable>
            </v-tab-item>
            <v-tab>Part number</v-tab>
            <v-tab-item>
              <PartNumberTable
                  title="Part number"
                  dtoListQuery="PartNumberListQueryDTO"
                  :store-name="storePartNumberTableName"
                  :detail-store-name="storePartNumberDetailName"
                  :height="componentHeight - 180"
                  :headers="partNumberHeaders"
                  :embedded="true"
              >
                <template v-slot:top>{{ '' }}</template>
                <template
                    v-slot:footer.prepend
                    v-if="currentItem.is_group"
                >{{ '' }}
                </template>
              </PartNumberTable>
            </v-tab-item>
          </v-tabs>
        </v-sheet>
      </template>
    </CommonDetail>

    <v-dialog
        v-if="!!detailStoreCasePackage"
        ref="detailCasePackageDialog"
        v-model="detailStoreCasePackage.dialogDetail"
        persistent
        scrollable
    >
      <CoreCasePackageDetail
          :uid-item="detailStoreCasePackage.uidItem"
          :store-name="detailStoreCasePackageName"
          :modalDialog="true"
          :route-full-screen="{name: 'CasePackageDetail', params: {itemUid: detailStoreCasePackage.uidItem}}"
          :main-validator="true"
      ></CoreCasePackageDetail>
    </v-dialog>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import {useTableStore} from "@/components/Common/CommonTable";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonSelectFromTable from "@/components/Common/CommonSelectFromTable";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import BaseImageCard from "@/components/Base/BaseImageCard";
import CommonFieldText from "@/components/Common/CommonFieldText";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import BaseStatusIcon from "@/components/Base/BaseStatusIcon";
import CommonBtnAction from "@/components/Common/CommonBtnAction";
import MaterialTable from "@/components/CoreMaterial/Material/MaterialTable";
import {useActionStore} from "@/components/Common/CommonBtnActionGroup";
import ProviderComponentTable from "@/components/CoreComponent/ProviderComponent/ProviderComponentTable";
import CoreCasePackageSupplyDefault from "@/components/CoreComponent/CasePackage/CoreCasePackageSupplyDefault";
import CommonFieldLink from "@/components/Common/CommonFieldLink";
import CommonFieldSelect from "@/components/Common/CommonFieldSelect";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber";
import ComponentMsdSelect from "@/components/CoreComponent/Component/ComponentMsdSelect";
import CoreSpecAttrComponentTable from "@/components/CoreComponent/SpecAttrComponent/CoreSpecAttrComponentTable";
import CoreCasePackageDetail from "@/components/CoreComponent/CasePackage/CoreCasePackageDetail";
import {debounce} from "debounce";
import CoreComponentAttrList from "@/components/CoreComponent/SpecAttrComponent/CoreComponentAttrList.vue";
import CommonHTMXComponent from "@/components/Common/CommonHTMXComponent.vue";

export default {
  name: "ComponentDetail",

  props: {
    uidItem: {default: null},
    // storeName: {type: [String], default: 'ComponentDetail'},
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoDetailQuery: {default: 'ComponentDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ComponentActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'ComponentSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'ComponentValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'ComponentDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CoreComponentTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonHTMXComponent,
    CoreComponentAttrList,
    CommonFieldString,
    CommonDetail,
    CommonSelectFromTable,
    CommonPartialSelectFromTable,
    BaseImageCard,
    CommonFieldText,
    CommonFieldNumber,
    CommonFieldLink,
    CommonFieldSelect,
    BaseFieldCheck,
    CoreCasePackageSupplyDefault,
    BaseStatusIcon,
    CommonBtnAction,
    MaterialTable,
    ProviderComponentTable,
    PartNumberTable: () => import("@/components/CoreComponent/PartNumber/PartNumberTable"),
    ComponentTable: () => import("@/components/CoreComponent/Component/ComponentTable"),
    // CoreBomTable: () => import("@/components/CoreComponent/Bom/CoreBomTable"),
    CustomerOrderTable: () => import("@/components/CoreComponent/CustomerOrder/CustomerOrderTable"),
    ComponentMsdSelect,
    CoreSpecAttrComponentTable,
    CoreCasePackageDetail,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
    status_tab_article_color() {
      if (this.currentItem.row_statuses.error_status === 'SUCCESS')
        return 'green accent-4'
      if (this.currentItem.row_statuses.error_status === 'WARNING')
        return 'orange accent-4'
      if (this.currentItem.row_statuses.error_status === 'ERROR')
        return 'red accent-4'
      return null
    },
    version() {
      if (!!this.currentItem)
        return this.currentItem.version
      else
        return null
    },
    category() {
      if (!!this.subcategory_uid && !!this.storeAggregate.rootData[this.subcategory_uid].category_uid &&
          !!this.storeAggregate.rootData[this.storeAggregate.rootData[this.subcategory_uid].category_uid]
      )
        return this.storeAggregate.rootData[this.storeAggregate.rootData[this.subcategory_uid].category_uid].category
      else
        return null
    },
    partNumberHeaders() {
      if (this.is_group)
        return this.partNumberHeadersGroup
      else
        return this.partNumberHeadersComponent
    },
    componentHeight() {
      if (this.modalDialog) {
        return this.$vuetify.breakpoint.height * 0.90 - 39
      } else {
        return this.$vuetify.breakpoint.height - 39
      }
    },
    subcategory_uid() {
      if (!!this.currentItem)
        return this.currentItem.subcategory_uid
      else
        return null
    },
    case_package_uid() {
      if (!!this.currentItem)
        return this.currentItem.case_package_uid
      else
        return null
    },
    case_package() {
      if (!!this.case_package_uid)
        return this.storeAggregate.rootData[this.case_package_uid]
      else
        return null
    },
    masterSupplyInformation() {
      if (this.case_package === null || this.category === null)
        return null
      if (this.category === 'resistors')
        return this.case_package.default_supply_information.resistor
      if (this.category === 'capacitors')
        return this.case_package.default_supply_information.capacitor
      return this.case_package.default_supply_information.common
    },
    provider_uid() {
      if (!!this.currentItem)
        return this.currentItem.provider_uid
      else
        return null
    },
    case_package_type() {
      if (!!this.case_package)
        return this.case_package.case_package_type
      else
        return null
    },
    is_group() {
      if (!!this.currentItem)
        return this.currentItem.is_group
      else
        return false
    },
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
  },

  watch: {
    storeUidItem: {
      handler(newValue, oldValue) {
        // console.log('watch ComponentDetail uidItem', newValue, oldValue)
        this.filterQueryGroupTable()
        this.filterQueryMaterialTable()
        this.filterQueryCustomerOrderTable()
        this.filterQueryInMembersTable()
        this.filterQueryOutMembersTable()
        this.partNumberFilter()
        this.storePartNumberDetail.parentUid = this.storeDetail.uidItem

        this.filterQuerySpecAttr()
        this.filterQueryMainSpecAttr()
      },
      deep: true
    },
    version: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          console.log('Change version', newValue, oldValue)
          this.changeFilters()
        }
      },
      deep: true
    },
    case_package_uid: {
      handler(newValue, oldValue) {
        // console.log('Change version', newValue, oldValue)
        if (newValue !== oldValue && this.is_group === true) {
          this.filterQueryOutMembersTable()
        }
        this.filterQuerySubcategory()
      },
      deep: true
    },
    subcategory_uid: {
      handler(newValue, oldValue) {
        // console.log('Change version', newValue, oldValue)
        if (newValue !== oldValue && this.is_group === true) {
          this.filterQueryOutMembersTable()
        }
      },
      deep: true
    },
    is_group: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.partNumberFilter()
        }
      },
      deep: true
    },
  },

  methods: {
    changeFilters: debounce(function () {
      console.log('Change version. Set filters')
      this.filterQuerySubcategory()
      this.filterQueryMainSpecAttr()
    }, 2000),
    filterQueryProviderSelectTable() {
      this.storeProviderSelect.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'is_customer', value: true},
        ],
        enable: true,
      }
    },
    filterQueryGroupTable() {
      this.storeComponentGroupTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'components__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
    },
    filterQueryMaterialTable() {
      this.storeMaterialTable.query_filters = {
        and_concat: false,
        filter_list: [
          {param_compare: 'component__uid', value: this.storeDetail.uidItem},
          {param_compare: 'component__component__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
    },
    filterQueryCustomerOrderTable() {
      this.storeCustomerOrderTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'productorder__bomsheet__component__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
    },
    filterQueryInMembersTable() {
      this.storeComponentInMembersTable.uidItem = this.storeDetail.uidItem
      this.storeComponentInMembersTable.query_filters = {
        and_concat: false,
        filter_list: [
          {param_compare: 'component__uid', value: this.storeDetail.uidItem},
          {param_compare: 'components__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
    },
    filterQueryOutMembersTable() {
      this.storeComponentOutMembersTable.uidItem = this.storeDetail.uidItem
      this.storeComponentOutMembersTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'case_package__uid', value: this.case_package_uid, enable: !!this.case_package_uid},
          {param_compare: 'subcategory__uid', value: this.subcategory_uid, enable: !!this.subcategory_uid},
          {param_compare: 'component__uid', value: this.storeDetail.uidItem, negative: true}
        ],
        enable: true,
      }
    },
    filterQuerySpecAttr() {
      this.storeSpecAttrComponentTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'component__uid', value: this.storeUidItem},
        ],
        enable: true,
      }
    },
    filterQuerySubcategory() {
      if (!this.storeAggregate || !this.storeDetail || !this.storeDetail.uidItem ||
          !this.storeSubcategoryTable.dtoListQuery || !this.storeAggregate.uid_dict[this.storeDetail.uidItem] ||
          this.storeAggregate.uid_dict[this.storeDetail.uidItem].case_package_uid !== this.case_package_uid)
        return
      this.storeSubcategoryTable.uidItem = this.storeDetail.uidItem
      let prevCasePackageUid = null
      if (!!this.storeSubcategoryTable && !!this.storeSubcategoryTable.query_filters
          && !!this.storeSubcategoryTable.query_filters.filter_list.length > 0)
        prevCasePackageUid = this.storeSubcategoryTable.query_filters.filter_list[0].value
      else
        prevCasePackageUid = null
      this.storeSubcategoryTable.query_filters = {
        and_concat: true,
        filter_list: [
          {
            param_compare: 'casepackage__uid',
            value: this.case_package_uid,
            enable: !!this.case_package_uid
          },
          {param_compare: 'valid', value: true},
        ],
        enable: true,
      }
      if (prevCasePackageUid !== this.case_package_uid)
        this.storeSubcategoryTable.update()
    },
    filterQueryMainSpecAttr() {
      this.storeMainSpecAttrComponentTable.uidItem = this.storeDetail.uidItem
      this.storeMainSpecAttrComponentTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'component__uid', value: this.storeUidItem, enable: !!this.storeUidItem},
          {param_compare: 'attribute__subcategory__uid', value: this.subcategory_uid, enable: !!this.subcategory_uid},
          {param_compare: 'deleted', value: null, enable: !!!this.subcategory_uid},
        ],
        enable: true,
      }
    },
    partNumberFilter() {
      // console.log('partNumberFilter', this.is_group)
      this.storePartNumberTable.query_filters = {
        and_concat: false,
        filter_list: [
          {param_compare: 'component__uid', value: this.storeDetail.uidItem, enable: this.is_group === false},
          {param_compare: 'component__component__uid', value: this.storeDetail.uidItem, enable: this.is_group === true},
        ],
        enable: true,
      }
    },
    defaultNewComponentProviderItem() {
      return {
        uid: uuidv4(),
        part_number: 'test_part_number',
        component_uid: this.currentItem.uid,
      }
    },
    createArticleSelected() {
      this.storeAggregate.fetchAction({
        storeName: this.storeName,
        dtoActionCommand: this.dtoActionCommand,
        uidItem: this.state.uidItem,
        uidSelected: [this.state.uidItem],
        actionName: 'create_article',
        callBack: null
      })
    },
    onAlternateAction(event) {
      // console.log('onAlternateAction', event)
      if (event.actionName === 'alternate_remove_from_group')
        this.storeComponentInMembersTable.onAction({
          actionName: 'remove_from_group', actionUid: event.actionUid,
        })
      if (event.actionName === 'alternate_add_to_group')
        this.storeComponentOutMembersTable.onAction({
          actionName: 'add_to_group', actionUid: event.actionUid,
        })
    },
  },

  mounted() {
    this.storeAggregate = useAggregateStore()
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeMaterialTable = useTableStore(this.storeMaterialTableName)()
    this.filterQueryMaterialTable()
    this.storeSubcategoryTable = useTableStore(this.storeSubcategoryName)()
    this.filterQuerySubcategory()
    this.storeCustomerOrderTable = useTableStore(this.storeCustomerOrderTableName)()
    this.filterQueryCustomerOrderTable()
    this.storeComponentGroupTable = useTableStore(this.storeComponentGroupTableName)()
    this.filterQueryGroupTable()
    this.storeComponentInMembersTable = useTableStore(this.storeComponentInMembersTableName)()
    this.filterQueryInMembersTable()
    this.storeComponentOutMembersTable = useTableStore(this.storeComponentOutMembersTableName)()
    this.filterQueryOutMembersTable()
    this.storeActionStore = useActionStore('CommonBtnActionGroup')()

    this.storePartNumberTable = useTableStore(this.storePartNumberTableName)()
    this.partNumberFilter()
    this.storePartNumberDetail = useDetailStore(this.storePartNumberDetailName)()

    this.storeProviderSelect = useTableStore(this.storeProviderSelectName)()
    this.filterQueryProviderSelectTable()

    this.storeSpecAttrComponentTable = useTableStore(this.storeSpecAttrComponentTableName)()
    this.filterQuerySpecAttr()

    this.storeMainSpecAttrComponentTable = useTableStore(this.storeMainSpecAttrComponentTableName)()
    this.filterQueryMainSpecAttr()

    this.detailStoreCasePackage = useDetailStore(this.detailStoreCasePackageName)()
  },

  data() {
    return {
      detailStoreCasePackage: null,
      detailStoreCasePackageName: uuidv4(),
      storeSubcategoryTable: null,
      storeSubcategoryName: uuidv4(),
      checkboxTrueData: true,
      storeDetail: null,
      storeAggregate: null,
      storeMaterialTable: null,
      storeCustomerOrderTable: null,
      storeComponentInMembersTable: null,
      storeComponentOutMembersTable: null,
      storeProviderComponentTable: null,
      storePartNumberTable: null,

      storeSpecAttrComponentTableName: uuidv4(),
      storeSpecAttrComponentTable: null,
      storeMainSpecAttrComponentTable: null,

      storeMaterialTableName: uuidv4(),
      storeCustomerOrderTableName: uuidv4(),
      storeComponentGroupTableName: uuidv4(),
      storeComponentInMembersTableName: uuidv4(),
      storeComponentOutMembersTableName: uuidv4(),
      storePartNumberTableName: uuidv4(),
      storePartNumberDetailName: uuidv4(),
      storeProviderSelectName: uuidv4(),
      storeMainSpecAttrComponentTableName: uuidv4(),
      materialHeaders: [
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
        // {text: 'Article', value: 'component__article_display', sortable: true, filterable: true, divider: true},
        // {text: 'Alias', value: 'component__alias', sortable: true, filterable: true, divider: true},
        {text: 'Provider', value: 'material_delivery__provider__name', sortable: true, filterable: true, divider: true},
        {text: 'P/N', value: 'part_number__part_number', sortable: true, filterable: true, divider: true},
        {text: 'Initial QTY', value: 'initial_qty', sortable: true, filterable: true, divider: true},
        {text: 'Current QTY', value: 'current_qty', sortable: true, filterable: true, divider: true},
        {text: 'Supply type', value: 'supply_type', sortable: false, filterable: true, divider: true, width: 100},
        {
          text: 'Reservation quantity',
          value: 'reservation_quantity',
          sortable: true,
          filterable: true,
          divider: true,
          width: 40
        },
        {text: 'State', value: 'state', sortable: true, filterable: true, divider: true, width: 100},
        {text: 'Location', value: 'location__name', sortable: true, filterable: true, divider: true, width: 100},
        {
          text: 'Parent location',
          value: 'location__parent__name',
          sortable: true,
          filterable: true,
          divider: true,
          width: 100
        },
        // {text: 'Parent', value: 'parent_uid', sortable: true, filterable: true, divider: true},
        {text: 'Edited by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'Edited on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: 'Created by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'Created on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ],
      membersHeaders: [
        // {text: 's', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 10, type: 'status'},
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'G', value: 'is_group', sortable: true, filterable: true, divider: true, width: 30, type: 'bool'},
        {text: 'Article', value: 'article_display', sortable: true, filterable: true, divider: true, width: 50},
        {text: 'Alias', value: 'alias', sortable: true, filterable: true, divider: true, width: 150},
        {text: 'MPN', value: 'mpn', sortable: true, filterable: true, divider: true, width: 150},
        {
          text: 'Case/Package',
          value: 'case_package_uid',
          sortable: true,
          filterable: true,
          divider: true,
          width: 50
        },
        {
          text: 'CasePackage type',
          value: 'case_package__case_package_type',
          sortable: false,
          filterable: true,
          divider: true,
          width: 50
        },
        {
          text: 'subcategory',
          value: 'subcategory_uid',
          article_type: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {
          text: 'Category',
          value: 'subcategory__category__category',
          sortable: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {
          text: 'Article parameters',
          value: 'main_attributes',
          sortable: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ],
      groupsHeaders: [
        // {text: 's', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 10, type: 'status'},
        // {text: 't', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'G', value: 'is_group', sortable: true, filterable: true, divider: true, width: 30, type: 'bool'},
        {text: 'Article', value: 'article_display', sortable: true, filterable: true, divider: true, width: 50},
        {text: 'Alias', value: 'alias', sortable: true, filterable: true, divider: true, width: 150},
        // {text: 'MPN', value: 'mpn', sortable: true, filterable: true, divider: true, width: 150},
        {
          text: 'case_package',
          value: 'case_package_uid',
          article_type: true,
          filterable: true,
          divider: true,
          width: 50
        },
        {
          text: 'CasePackage type',
          value: 'case_package__case_package_type',
          sortable: false,
          filterable: true,
          divider: true,
          width: 50
        },
        {text: 'Subcategory', value: 'subcategory_uid', sortable: true, filterable: true, divider: true, width: 150},
        {
          text: 'Category',
          value: 'subcategory__category__category',
          sortable: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {
          text: 'Article parameters',
          value: 'main_attributes',
          sortable: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ],
      partNumberHeadersComponent: [
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
        {text: 'Provider', value: 'provider__name', sortable: true, filterable: true, divider: true},
        {text: 'P/N', value: 'part_number', sortable: true, filterable: true, divider: true},
        {text: 'Article', value: 'component__article_display', sortable: true, filterable: true, divider: true},
        {text: 'Component', value: 'component', sortable: true, filterable: true, divider: true},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ],
      partNumberHeadersGroup: [
        {text: 'P/N', value: 'part_number', sortable: true, filterable: true, divider: true},
        {text: 'Provider', value: 'provider', sortable: true, filterable: true, divider: true},
        {text: 'Article', value: 'component__article_display', sortable: true, filterable: true, divider: true},
        {text: 'Component', value: 'component', sortable: true, filterable: true, divider: true},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
      ],
      specAttrHeader: [
        {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
        {
          text: 'Attribute group',
          value: 'attribute__group',
          sortable: true,
          filterable: true,
          divider: true,
          width: 150
        },
        {text: 'Attribute name', value: 'attribute__name', sortable: true, filterable: true, divider: true, width: 150},
        // {text: 'Article MPN', value: 'component__mpn', sortable: true, filterable: true, divider: true, width: 150},
        {text: 'Display value', value: 'display_value', sortable: true, divider: true},
        {
          text: 'Manual changed',
          value: 'manual_changed',
          sortable: false,
          filterable: true,
          divider: true,
          type: 'bool',
          width: 100
        },
      ],
      mainSpecAttrComponentHeaders: [
        {
          text: 'Attribute name',
          value: 'attribute__name',
          sortable: false,
          filterable: true,
          divider: false,
          width: 100
        },
        {text: 'Display value', value: 'display_value', sortable: false, filterable: true, divider: false, width: 60},
      ],
      headersAttr: [
        {text: 'group', value: 'group', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'name', value: 'name', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'value', value: 'value', sortable: false, filterable: true, divider: true, width: 50},
      ]
    }
  },
}
</script>


<style scoped>
</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>